
import animeData from '~/static/lottiefiles/circle.json'
import { sortBanners } from '~/utils/sortSpecBanners'

export default {
  name: 'CatalogPage',

  async asyncData({ app, env, $axios }) {
    const currentLocale = app.i18n.locale
    let seo
    let faq
    let catalogBanners
    let sortedSpecBanners
    let sizeCatalogs
    let categories
    let footer
    let specCatalog

    try {
      const response = await $axios.$post(`${env.API_URL_SITE}/seo`, {
        url: '/catalog',
        project: 'korzinka.uz'
      })

      seo = response?.data?.items
      faq = response?.data?.items?.[currentLocale]?.[0]?.QNA
    } catch (e) {}

    try {
      const response = await $axios.$get('/catalogs/banners')
      const footerResponse = await $axios.$get('/catalog-footer')
      footer = footerResponse.catalog_footer
      function textToArray(text) {
        // Разделяем текст по символу перевода строки
        return text.split(/\n|\*/).filter((item) => {
          return item.trim() !== ''
        })
      }
      footer.text_ru = textToArray(footerResponse.catalog_footer.text)
      footer.text_en = textToArray(footerResponse.catalog_footer.text_en)
      footer.text_uz = textToArray(footerResponse.catalog_footer.text_uz)
      if (response) {
        catalogBanners = response

        sortedSpecBanners = sortBanners(catalogBanners.staticCatalogs)

        sizeCatalogs =
          catalogBanners?.standardCatalogs.length +
          catalogBanners.staticCatalogs.length

        if (catalogBanners?.standardCatalogs[0] === null) {
          sizeCatalogs--
        }
      }
    } catch (e) {}

    try {
      const categoriesResponse = await $axios.get('/catalogs/categories')
      const catalog = await $axios.get('/mobile/catalogs-list')
      categories = categoriesResponse.data.data
      specCatalog = catalog.data.data[0]
    } catch (e) {}

    return {
      seo,
      faq,
      catalogBanners,
      sizeCatalogs,
      categories,
      specCatalog,
      sortedSpecBanners,
      footer
    }
  },

  data() {
    return {
      seo: null,
      faq: null,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        infinite: false,
        draggable: false,
        variableWidth: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 500,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      },

      bannerSettings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        draggable: false,
        dots: false,
        responsive: [
          {
            breakpoint: 500,
            settings: {
              draggable: false
            }
          },
          {
            breakpoint: 0,
            settings: {
              draggable: true
            }
          }
        ]
      },

      isUploadedData: false,

      fromTop10FirstItem: null,

      floatCategories: [],

      bestOfferCategory: [],
      topBestOfferCategory: [],
      products: [],
      floatTabs: [],
      setProducts: [],

      sizeCatalogs: 0,

      prevIconLottiefile: null,
      nextIconLottiefile: null,

      // categories: [],
      specCatalog: [],
      banners: [],
      currentQueryParam: 'best-offers',
      catalogBanners: []
    }
  },

  head() {
    const scripts = []
    if (this?.faq.length) {
      scripts.push({
        hid: 'ldjson-schema',
        type: 'application/ld+json',
        json: {
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          mainEntity: this.faq.map((item) => ({
            '@type': 'Question',
            name: item.question,
            acceptedAnswer: {
              '@type': 'Answer',
              text: item.answer
            }
          }))
        }
      })
    }

    const metaTags = [
      { hid: 'og:type', property: 'og:type', content: 'website' },
      {
        hid: 'description',
        name: 'description',
        content: this.seo[this.$i18n.locale][0].description
      },
      {
        hid: 'og-title',
        property: 'og:title',
        content: this.seo[this.$i18n.locale][0].og_title
      },
      {
        hid: 'og-description',
        property: 'og:description',
        content: this.seo[this.$i18n.locale][0].og_description
      },
      {
        hid: 'og-url',
        property: 'og:url',
        content: this.seo[this.$i18n.locale][0].og_url
      },

      {
        hid: 'og-image',
        property: 'og:image',
        content: this.seo[this.$i18n.locale][0].og_img
      },
      {
        property: 'twitter:card',
        content: 'summary_large_image'
      }
    ]

    if (this.$route.query.category) {
      metaTags.push({
        hid: 'robots',
        name: 'robots',
        content: 'noindex, nofollow'
      })
    }

    return {
      title: this.seo[this.$i18n.locale][0].title,
      meta: metaTags,
      bodyAttrs: {
        class: 'about_body'
      },
      link: [
        {
          rel: 'canonical',
          href: `https://korzinka.uz/${
            this.$i18n.locale === 'ru' ? '' : this.$i18n.locale + '/'
          }catalog`
        },
        {
          rel: 'alternate',
          href: `https://korzinka.uz/catalog`,
          hreflang: 'ru'
        },
        {
          rel: 'alternate',
          href: `https://korzinka.uz/uz/catalog`,
          hreflang: 'uz'
        },
        {
          rel: 'alternate',
          href: `https://korzinka.uz/en/catalog`,
          hreflang: 'en'
        }
      ],
      script: [...scripts]
    }
  },

  // jsonld() {
  //   const data = this.seo[this.$i18n.locale].QNA?.map((i) => ({
  //     '@type': 'Question',
  //     name: i.question,
  //     acceptedAnswer: {
  //       '@type': 'Answer',
  //       text: i.answer
  //     }
  //   }))

  //   return {
  //     // '@context': 'https://schema.org',
  //     // '@type': 'FAQPage',
  //     itemListElement: data
  //   }
  // },

  // watch: {
  //   categories: "initLottieFilesStatic"
  // },

  mounted() {
    // this.fetchBanners()
    this.fetchSortedBnners()
    this.detectQueryParam()

    this.fetchCatalogs()

    this.initLottieFiles()
  },

  destroyed() {
    window.removeEventListener('scroll', this.navHighlighter)
  },
  computed: {
    uniqueCategories() {
      const uniqueIds = new Set()
      const uniqueCategories = this.floatTabs.filter((category) => {
        if (!uniqueIds.has(category.id)) {
          uniqueIds.add(category.id)
          return true
        }
        return false
      })
      return uniqueCategories
    }
  },
  methods: {
    fetchSortedBnners() {
      this.sortedSpecBanners = sortBanners(this.catalogBanners?.staticCatalogs)
    },
    dateFormat(date) {
      const d = new Date(date)
      const day = String(d.getDate()).padStart(2, '0')
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const year = d.getFullYear()
      return `${day}.${month}.${year}`
    },
    // async fetchBanners() {
    //   try {
    //     const { catalogs, sizeCatalogs } = await this.$store.dispatch(
    //       'catalogs/fetchBanners'
    //     )
    //     this.catalogBanners = catalogs
    //     this.sizeCatalogs = sizeCatalogs
    //   } catch (error) {
    //     throw error
    //   }
    // },

    fetchCatalogs() {
      // const locCategories = localStorage.getItem('categories')
      // const locSpecCatalog = localStorage.getItem('specCatalog')

      // let isUpdated = null

      // const isCachedDatas = locCategories === null && locSpecCatalog === null

      // if (locSpecCatalog !== null) {
      //   isUpdated = JSON.parse(locSpecCatalog)
      // } else {
      //   isUpdated = await this.$axios.get('/mobile/catalogs-list')
      //   isUpdated = isUpdated.data.data[0]
      // }

      // try {
      //   const isUpdatedCatalog = await this.$axios.post(
      //     '/application/catalogs/is-actual',
      //     {
      //       catalog_id: Number(isUpdated.id),
      //       catalog_updated_at: String(isUpdated.updated_at)
      //     }
      //   )

      //   const result = isUpdatedCatalog.data.result
      // } catch (e) {}

      try {
        // localStorage.removeItem('categories')
        // localStorage.removeItem('specCatalog')

        if (this.categories[0]) {
          this.productSplicer()

          setTimeout(() => {
            this.initScrollMagic()
            this.tabsObserver()
          }, 100)
        }
      } catch (e) {}
    },

    scrollHandler(e) {
      const target = e.target
      const attr = target.getAttribute('data-id')
      const el = this.$el.querySelector(`[data-category='${attr}']`)
      const offset = 80 // Высота смещения в пикселях

      window.scrollTo({ top: el.offsetTop - offset, behavior: 'smooth' })
    },

    productSplicer() {
      this.floatTabs = [...this.categories]
    },

    firstMarkProductCollector() {
      const tabs = this.$el.querySelectorAll('.catalog-page__tab-link')
      const currTabs = this.$el.querySelectorAll('.catalog-page__tab-icon')

      tabs[0].classList.add('catalog-page__tab-link_active')
      if (currTabs.length > 0 && currTabs[0] && currTabs[1]) {
        currTabs[0].insertAdjacentHTML(
          'beforeend',
          '<svg width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg"><mask id="path-1-inside-1_3158_297690" fill="#222025"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.31955 8.6061C0.157771 7.22889 0.597298 5.60978 1.337 4.35217C2.92189 1.65555 5.83288 -0.222044 8.83154 0.470491C9.19673 0.555631 9.41862 0.676723 9.54668 0.792772L9.57162 0.815371L9.59998 0.833485C10.7765 1.58489 11.2456 2.64887 11.229 3.83308C11.2121 5.04026 10.6868 6.3881 9.82529 7.62932C8.96629 8.86699 7.79583 9.96512 6.53917 10.6777C5.27883 11.3925 3.97059 11.6986 2.81408 11.4272C1.98736 11.2344 1.41095 10.8573 1.01984 10.3794C0.625872 9.89802 0.399819 9.28942 0.31955 8.6061ZM7.22556 2.72115L7.10002 2.61052L6.93311 2.62223C6.57528 2.64733 6.24774 2.82118 5.97135 3.03201C5.69087 3.24596 5.4299 3.52339 5.20047 3.80919C4.74196 4.38036 4.3721 5.03206 4.19078 5.41551L4.18948 5.41831C4.03726 5.74676 3.73353 6.61037 3.63353 7.37775C3.58506 7.74976 3.5733 8.17346 3.71035 8.5052C3.78372 8.68278 3.90867 8.85501 4.11004 8.96135C4.30934 9.06661 4.53333 9.0808 4.75571 9.04023C5.00638 8.99521 5.24503 8.86471 5.458 8.70502C5.67486 8.54241 5.88904 8.33145 6.09237 8.09282C6.49899 7.61561 6.88651 6.99915 7.18522 6.35635C7.48281 5.71596 7.70368 5.0249 7.75594 4.39848C7.80728 3.78317 7.70064 3.13982 7.22556 2.72115ZM5.68254 21.6426C5.56362 21.4802 5.50028 21.2271 5.73776 20.8022L15.3081 3.59372C15.4768 3.29057 15.806 3.05609 16.2411 2.91831C16.6737 2.78131 17.1701 2.75446 17.6046 2.83205C18.0497 2.91155 18.3633 3.08702 18.5099 3.28722C18.6288 3.44968 18.6917 3.70351 18.4542 4.1284L8.88432 21.3362C8.71559 21.6393 8.38644 21.8738 7.95133 22.0116C7.5187 22.1486 7.02231 22.1754 6.58782 22.0978C6.14268 22.0183 5.82908 21.8428 5.68254 21.6426ZM15.1119 16.1195C16.6967 13.423 19.6136 11.5467 22.6068 12.238C22.9776 12.3236 23.2009 12.4465 23.3282 12.5637L23.3539 12.5873L23.3832 12.6061C24.557 13.3588 25.0242 14.4231 25.0062 15.6072C24.9878 16.8142 24.4614 18.1612 23.5994 19.4013C22.7398 20.6379 21.5692 21.7348 20.3127 22.4465C19.0526 23.1603 17.7448 23.4659 16.5889 23.1946C15.7621 23.0018 15.1857 22.6247 14.7946 22.1468C14.4007 21.6655 14.1746 21.0569 14.0944 20.3736C13.9326 18.9963 14.3722 17.3771 15.1119 16.1195ZM21.0059 14.4895L20.881 14.3795L20.715 14.3906C20.3562 14.4145 20.0277 14.5872 19.7502 14.7976C19.4689 15.011 19.2075 15.2881 18.9779 15.574C18.5199 16.1443 18.151 16.7968 17.9707 17.1858C17.8177 17.5089 17.4875 18.3743 17.3736 19.1453C17.3185 19.5181 17.3005 19.9492 17.4471 20.2868C17.5264 20.4694 17.6606 20.6392 17.8697 20.7403C18.0739 20.8391 18.3027 20.8495 18.532 20.8074C18.7823 20.7614 19.0207 20.6304 19.2337 20.4703C19.4505 20.3073 19.6646 20.096 19.868 19.8571C20.2748 19.3794 20.6625 18.7628 20.9615 18.1202C21.2594 17.4801 21.4807 16.7896 21.5337 16.1641C21.5857 15.55 21.4804 14.9071 21.0059 14.4895Z"></path></mask> <path fill-rule="evenodd" clip-rule="evenodd" d="M0.31955 8.6061C0.157771 7.22889 0.597298 5.60978 1.337 4.35217C2.92189 1.65555 5.83288 -0.222044 8.83154 0.470491C9.19673 0.555631 9.41862 0.676723 9.54668 0.792772L9.57162 0.815371L9.59998 0.833485C10.7765 1.58489 11.2456 2.64887 11.229 3.83308C11.2121 5.04026 10.6868 6.3881 9.82529 7.62932C8.96629 8.86699 7.79583 9.96512 6.53917 10.6777C5.27883 11.3925 3.97059 11.6986 2.81408 11.4272C1.98736 11.2344 1.41095 10.8573 1.01984 10.3794C0.625872 9.89802 0.399819 9.28942 0.31955 8.6061ZM7.22556 2.72115L7.10002 2.61052L6.93311 2.62223C6.57528 2.64733 6.24774 2.82118 5.97135 3.03201C5.69087 3.24596 5.4299 3.52339 5.20047 3.80919C4.74196 4.38036 4.3721 5.03206 4.19078 5.41551L4.18948 5.41831C4.03726 5.74676 3.73353 6.61037 3.63353 7.37775C3.58506 7.74976 3.5733 8.17346 3.71035 8.5052C3.78372 8.68278 3.90867 8.85501 4.11004 8.96135C4.30934 9.06661 4.53333 9.0808 4.75571 9.04023C5.00638 8.99521 5.24503 8.86471 5.458 8.70502C5.67486 8.54241 5.88904 8.33145 6.09237 8.09282C6.49899 7.61561 6.88651 6.99915 7.18522 6.35635C7.48281 5.71596 7.70368 5.0249 7.75594 4.39848C7.80728 3.78317 7.70064 3.13982 7.22556 2.72115ZM5.68254 21.6426C5.56362 21.4802 5.50028 21.2271 5.73776 20.8022L15.3081 3.59372C15.4768 3.29057 15.806 3.05609 16.2411 2.91831C16.6737 2.78131 17.1701 2.75446 17.6046 2.83205C18.0497 2.91155 18.3633 3.08702 18.5099 3.28722C18.6288 3.44968 18.6917 3.70351 18.4542 4.1284L8.88432 21.3362C8.71559 21.6393 8.38644 21.8738 7.95133 22.0116C7.5187 22.1486 7.02231 22.1754 6.58782 22.0978C6.14268 22.0183 5.82908 21.8428 5.68254 21.6426ZM15.1119 16.1195C16.6967 13.423 19.6136 11.5467 22.6068 12.238C22.9776 12.3236 23.2009 12.4465 23.3282 12.5637L23.3539 12.5873L23.3832 12.6061C24.557 13.3588 25.0242 14.4231 25.0062 15.6072C24.9878 16.8142 24.4614 18.1612 23.5994 19.4013C22.7398 20.6379 21.5692 21.7348 20.3127 22.4465C19.0526 23.1603 17.7448 23.4659 16.5889 23.1946C15.7621 23.0018 15.1857 22.6247 14.7946 22.1468C14.4007 21.6655 14.1746 21.0569 14.0944 20.3736C13.9326 18.9963 14.3722 17.3771 15.1119 16.1195ZM21.0059 14.4895L20.881 14.3795L20.715 14.3906C20.3562 14.4145 20.0277 14.5872 19.7502 14.7976C19.4689 15.011 19.2075 15.2881 18.9779 15.574C18.5199 16.1443 18.151 16.7968 17.9707 17.1858C17.8177 17.5089 17.4875 18.3743 17.3736 19.1453C17.3185 19.5181 17.3005 19.9492 17.4471 20.2868C17.5264 20.4694 17.6606 20.6392 17.8697 20.7403C18.0739 20.8391 18.3027 20.8495 18.532 20.8074C18.7823 20.7614 19.0207 20.6304 19.2337 20.4703C19.4505 20.3073 19.6646 20.096 19.868 19.8571C20.2748 19.3794 20.6625 18.7628 20.9615 18.1202C21.2594 17.4801 21.4807 16.7896 21.5337 16.1641C21.5857 15.55 21.4804 14.9071 21.0059 14.4895Z" fill="#222025"></path> <path d="M1.337 4.35217L2.19895 4.85916L2.19913 4.85887L1.337 4.35217ZM0.31955 8.6061L1.31272 8.48944L0.31955 8.6061ZM8.83154 0.470491L9.05859 -0.503395L9.05657 -0.503862L8.83154 0.470491ZM9.54668 0.792772L8.87519 1.53378L8.87519 1.53378L9.54668 0.792772ZM9.57162 0.815371L8.90012 1.55638L8.96246 1.61287L9.03337 1.65815L9.57162 0.815371ZM9.59998 0.833485L9.06173 1.67627L9.06174 1.67627L9.59998 0.833485ZM11.229 3.83308L12.2289 3.84708V3.84708L11.229 3.83308ZM9.82529 7.62932L9.00376 7.05915V7.05915L9.82529 7.62932ZM6.53917 10.6777L7.03245 11.5476L6.53917 10.6777ZM2.81408 11.4272L3.04257 10.4537L3.04122 10.4533L2.81408 11.4272ZM1.01984 10.3794L0.245966 11.0127H0.245966L1.01984 10.3794ZM7.10002 2.61052L7.76118 1.86028L7.44734 1.58371L7.03006 1.61298L7.10002 2.61052ZM7.22556 2.72115L7.88671 1.97091V1.97091L7.22556 2.72115ZM6.93311 2.62223L7.00307 3.61978L6.93311 2.62223ZM5.97135 3.03201L6.57785 3.8271L6.57785 3.8271L5.97135 3.03201ZM5.20047 3.80919L5.98029 4.4352L5.98029 4.4352L5.20047 3.80919ZM4.19078 5.41551L3.28673 4.98801L3.28345 4.99508L4.19078 5.41551ZM4.18948 5.41831L5.09678 5.83879L5.09681 5.83874L4.18948 5.41831ZM3.63353 7.37775L4.62515 7.50697L3.63353 7.37775ZM3.71035 8.5052L2.78612 8.88702L2.78612 8.88702L3.71035 8.5052ZM4.11004 8.96135L4.57704 8.0771L4.57703 8.07709L4.11004 8.96135ZM4.75571 9.04023L4.57894 8.05598L4.57627 8.05647L4.75571 9.04023ZM5.458 8.70502L6.05791 9.50509L6.05791 9.50509L5.458 8.70502ZM6.09237 8.09282L5.33122 7.44425L5.33122 7.44425L6.09237 8.09282ZM7.18522 6.35635L6.27836 5.93492V5.93492L7.18522 6.35635ZM7.75594 4.39848L8.75248 4.48162V4.48162L7.75594 4.39848ZM5.73776 20.8022L6.61067 21.2901L6.6117 21.2882L5.73776 20.8022ZM5.68254 21.6426L6.48947 21.052L6.48947 21.052L5.68254 21.6426ZM15.3081 3.59372L14.4343 3.10738L14.4341 3.10769L15.3081 3.59372ZM16.2411 2.91831L15.9392 1.96496L15.9392 1.96496L16.2411 2.91831ZM17.6046 2.83205L17.4288 3.81648L17.6046 2.83205ZM18.5099 3.28722L17.7029 3.87786L17.7029 3.87787L18.5099 3.28722ZM18.4542 4.1284L17.5813 3.64052L17.5803 3.64237L18.4542 4.1284ZM8.88432 21.3362L9.75809 21.8225L9.75826 21.8222L8.88432 21.3362ZM7.95133 22.0116L8.25321 22.9649H8.25322L7.95133 22.0116ZM6.58782 22.0978L6.41201 23.0822H6.41201L6.58782 22.0978ZM22.6068 12.238L22.3818 13.2124L22.382 13.2124L22.6068 12.238ZM15.1119 16.1195L15.9739 16.6265L15.974 16.6262L15.1119 16.1195ZM23.3282 12.5637L22.6511 13.2996L22.6511 13.2996L23.3282 12.5637ZM23.3539 12.5873L22.6767 13.3232L22.7408 13.3821L22.8141 13.4291L23.3539 12.5873ZM23.3832 12.6061L22.8434 13.4479L22.8434 13.4479L23.3832 12.6061ZM25.0062 15.6072L26.0061 15.6224L25.0062 15.6072ZM23.5994 19.4013L24.4205 19.9721L23.5994 19.4013ZM20.3127 22.4465L19.8199 21.5764H19.8199L20.3127 22.4465ZM16.5889 23.1946L16.8174 22.2211L16.816 22.2208L16.5889 23.1946ZM14.7946 22.1468L15.5685 21.5135L15.5685 21.5135L14.7946 22.1468ZM14.0944 20.3736L13.1012 20.4902L14.0944 20.3736ZM20.881 14.3795L21.5417 13.6289L21.2294 13.3541L20.8145 13.3818L20.881 14.3795ZM21.0059 14.4895L21.6665 13.7388L21.0059 14.4895ZM20.715 14.3906L20.7815 15.3884L20.715 14.3906ZM19.7502 14.7976L19.1459 14.0009L19.1459 14.0009L19.7502 14.7976ZM18.9779 15.574L19.7576 16.2002L19.7576 16.2002L18.9779 15.574ZM17.9707 17.1858L18.8746 17.6136L18.8779 17.6064L17.9707 17.1858ZM17.3736 19.1453L16.3843 18.9992V18.9992L17.3736 19.1453ZM17.4471 20.2868L18.3644 19.8885L17.4471 20.2868ZM17.8697 20.7403L18.3049 19.84L18.3049 19.84L17.8697 20.7403ZM18.532 20.8074L18.7126 21.7909H18.7126L18.532 20.8074ZM19.2337 20.4703L18.6327 19.6711L19.2337 20.4703ZM19.868 19.8571L20.6294 20.5054L19.868 19.8571ZM20.9615 18.1202L20.0548 17.6983L20.9615 18.1202ZM21.5337 16.1641L20.5373 16.0797V16.0797L21.5337 16.1641ZM0.475048 3.84519C-0.348361 5.2451 -0.866408 7.08159 -0.673621 8.72277L1.31272 8.48944C1.18195 7.37619 1.54296 5.97445 2.19895 4.85916L0.475048 3.84519ZM9.05657 -0.503862C5.48336 -1.32909 2.19242 0.923136 0.474876 3.84548L2.19913 4.85887C3.65135 2.38796 6.1824 0.884998 8.60652 1.44484L9.05657 -0.503862ZM10.2182 0.051766C9.92592 -0.213086 9.53047 -0.393379 9.05859 -0.503393L8.60449 1.44437C8.86299 1.50464 8.91133 1.56653 8.87519 1.53378L10.2182 0.051766ZM10.2431 0.0743638L10.2182 0.0517654L8.87519 1.53378L8.90012 1.55638L10.2431 0.0743638ZM10.1382 -0.00929755L10.1099 -0.0274115L9.03337 1.65815L9.06173 1.67627L10.1382 -0.00929755ZM12.2289 3.84708C12.25 2.34388 11.6289 0.942719 10.1382 -0.00930354L9.06174 1.67627C9.92415 2.22705 10.2412 2.95386 10.2291 3.81907L12.2289 3.84708ZM10.6468 8.1995C11.5802 6.8546 12.2084 5.31539 12.2289 3.84708L10.2291 3.81907C10.2159 4.76512 9.79327 5.9216 9.00376 7.05915L10.6468 8.1995ZM7.03245 11.5476C8.43058 10.7548 9.70975 9.54964 10.6468 8.19949L9.00376 7.05915C8.22282 8.18435 7.16108 9.17547 6.04588 9.80787L7.03245 11.5476ZM2.58559 12.4008C4.06911 12.7489 5.63942 12.3376 7.03245 11.5476L6.04588 9.80787C4.91824 10.4473 3.87207 10.6483 3.04257 10.4537L2.58559 12.4008ZM0.245966 11.0127C0.790574 11.6782 1.56764 12.1633 2.58695 12.4011L3.04122 10.4533C2.40708 10.3054 2.03132 10.0364 1.79371 9.74607L0.245966 11.0127ZM-0.673621 8.72277C-0.576275 9.55147 -0.294349 10.3525 0.245966 11.0127L1.79371 9.74607C1.54609 9.4435 1.37591 9.02738 1.31272 8.48944L-0.673621 8.72277ZM6.43886 3.36077L6.5644 3.4714L7.88671 1.97091L7.76118 1.86028L6.43886 3.36077ZM7.00307 3.61978L7.16999 3.60807L7.03006 1.61298L6.86314 1.62468L7.00307 3.61978ZM6.57785 3.8271C6.77766 3.67468 6.91958 3.62564 7.00307 3.61978L6.86314 1.62468C6.23098 1.66902 5.71782 1.96768 5.36485 2.23693L6.57785 3.8271ZM5.98029 4.4352C6.18047 4.18584 6.38428 3.97475 6.57785 3.8271L5.36485 2.23693C4.99746 2.51717 4.67934 2.86094 4.42065 3.18319L5.98029 4.4352ZM5.0948 5.84299C5.24901 5.51688 5.57934 4.93466 5.98029 4.4352L4.42065 3.18319C3.90457 3.82606 3.49518 4.54725 3.28676 4.98802L5.0948 5.84299ZM5.09681 5.83874L5.0981 5.83593L3.28345 4.99508L3.28215 4.99788L5.09681 5.83874ZM4.62515 7.50697C4.70971 6.85805 4.97912 6.09268 5.09678 5.83879L3.28218 4.99783C3.0954 5.40084 2.75735 6.36269 2.64192 7.24853L4.62515 7.50697ZM4.63458 8.12337C4.60334 8.04775 4.58072 7.84792 4.62515 7.50697L2.64192 7.24853C2.58939 7.6516 2.54326 8.29916 2.78612 8.88702L4.63458 8.12337ZM4.57703 8.07709C4.60075 8.08962 4.619 8.10614 4.62982 8.11909C4.63907 8.13017 4.63881 8.1336 4.63458 8.12337L2.78612 8.88702C2.92414 9.22111 3.18499 9.6037 3.64304 9.84561L4.57703 8.07709ZM4.57627 8.05647C4.55977 8.05947 4.54769 8.06065 4.53981 8.06104C4.53199 8.06142 4.52915 8.061 4.53063 8.06115C4.53226 8.06133 4.53802 8.0621 4.54685 8.0647C4.55586 8.06736 4.56628 8.07142 4.57704 8.0771L3.64303 9.84561C4.09426 10.0839 4.5605 10.0923 4.93516 10.024L4.57627 8.05647ZM4.8581 7.90495C4.71056 8.01557 4.61684 8.04918 4.57894 8.05598L4.93249 10.0245C5.39592 9.94125 5.7795 9.71385 6.05791 9.50509L4.8581 7.90495ZM5.33122 7.44425C5.16097 7.64405 4.99985 7.79866 4.85809 7.90495L6.05791 9.50509C6.34987 9.28617 6.61711 9.01884 6.85353 8.74139L5.33122 7.44425ZM6.27836 5.93492C6.01259 6.50683 5.67182 7.04453 5.33122 7.44425L6.85353 8.74139C7.32617 8.1867 7.76043 7.49147 8.09209 6.77777L6.27836 5.93492ZM6.75941 4.31534C6.72013 4.78614 6.54581 5.35939 6.27836 5.93492L8.09209 6.77777C8.41981 6.07254 8.68724 5.26367 8.75248 4.48162L6.75941 4.31534ZM6.5644 3.4714C6.68868 3.58092 6.80026 3.8256 6.75941 4.31534L8.75248 4.48162C8.81429 3.74075 8.7126 2.69872 7.88671 1.97091L6.5644 3.4714ZM4.86485 20.3143C4.68905 20.6288 4.57386 20.9694 4.57653 21.3282C4.57933 21.7052 4.71144 22.009 4.87561 22.2333L6.48947 21.052C6.50833 21.0777 6.53162 21.1164 6.54965 21.167C6.56814 21.219 6.57615 21.2697 6.57647 21.3134C6.57711 21.3988 6.54899 21.4004 6.61067 21.2901L4.86485 20.3143ZM14.4341 3.10769L4.86382 20.3161L6.6117 21.2882L16.182 4.07976L14.4341 3.10769ZM15.9392 1.96496C15.3493 2.15175 14.7659 2.51166 14.4343 3.10738L16.1819 4.08007C16.1877 4.06949 16.2626 3.96042 16.543 3.87165L15.9392 1.96496ZM17.7804 1.84763C17.1923 1.7426 16.5317 1.77734 15.9392 1.96496L16.543 3.87165C16.8157 3.78528 17.1479 3.76632 17.4288 3.81648L17.7804 1.84763ZM19.3168 2.69657C18.9571 2.20512 18.3538 1.95003 17.7804 1.84763L17.4288 3.81648C17.5687 3.84147 17.6601 3.87687 17.7097 3.90254C17.7643 3.93081 17.744 3.93397 17.7029 3.87786L19.3168 2.69657ZM19.3272 4.61628C19.503 4.30172 19.6181 3.96124 19.6157 3.60273C19.6132 3.22623 19.4817 2.92186 19.3168 2.69657L17.7029 3.87787C17.6837 3.85158 17.6603 3.81264 17.6424 3.76194C17.6239 3.71001 17.616 3.65944 17.6157 3.61607C17.6152 3.53131 17.643 3.53019 17.5813 3.64052L19.3272 4.61628ZM9.75826 21.8222L19.3282 4.61443L17.5803 3.64237L8.01038 20.8501L9.75826 21.8222ZM8.25322 22.9649C8.84309 22.7781 9.42651 22.4182 9.75809 21.8225L8.01055 20.8498C8.00467 20.8604 7.92979 20.9695 7.64945 21.0582L8.25322 22.9649ZM6.41201 23.0822C7.00011 23.1873 7.6607 23.1525 8.25321 22.9649L7.64946 21.0582C7.37669 21.1446 7.04451 21.1635 6.76363 21.1134L6.41201 23.0822ZM4.87561 22.2333C5.23533 22.7247 5.83859 22.9798 6.41201 23.0822L6.76363 21.1134C6.62371 21.0884 6.53235 21.053 6.48274 21.0273C6.42808 20.999 6.4484 20.9959 6.48947 21.052L4.87561 22.2333ZM22.8319 11.2637C19.2645 10.4398 15.9676 12.69 14.2498 15.6128L15.974 16.6262C17.4259 14.156 19.9626 12.6536 22.3818 13.2124L22.8319 11.2637ZM24.0054 11.8279C23.7113 11.5572 23.3105 11.3741 22.8317 11.2636L22.382 13.2124C22.6448 13.2731 22.6905 13.3358 22.6511 13.2996L24.0054 11.8279ZM24.031 11.8515L24.0054 11.8279L22.6511 13.2996L22.6767 13.3232L24.031 11.8515ZM23.923 11.7643L23.8937 11.7455L22.8141 13.4291L22.8434 13.4479L23.923 11.7643ZM26.0061 15.6224C26.029 14.1198 25.4106 12.7182 23.923 11.7643L22.8434 13.4479C23.7034 13.9994 24.0195 14.7263 24.0063 15.5919L26.0061 15.6224ZM24.4205 19.9721C25.3545 18.6283 25.9837 17.0902 26.0061 15.6224L24.0063 15.5919C23.9919 16.5381 23.5683 17.694 22.7783 18.8305L24.4205 19.9721ZM20.8056 23.3166C22.2035 22.5248 23.4828 21.321 24.4205 19.9721L22.7783 18.8305C21.9968 19.9548 20.9349 20.9448 19.8199 21.5764L20.8056 23.3166ZM16.3604 24.1682C17.843 24.5162 19.4128 24.1056 20.8056 23.3166L19.8199 21.5764C18.6924 22.2151 17.6465 22.4157 16.8174 22.2211L16.3604 24.1682ZM14.0208 22.7802C14.5654 23.4456 15.3424 23.9308 16.3617 24.1685L16.816 22.2208C16.1819 22.0729 15.8061 21.8038 15.5685 21.5135L14.0208 22.7802ZM13.1012 20.4902C13.1985 21.3189 13.4804 22.12 14.0208 22.7802L15.5685 21.5135C15.3209 21.2109 15.1507 20.7948 15.0875 20.2569L13.1012 20.4902ZM14.25 15.6125C13.4266 17.0124 12.9084 18.849 13.1012 20.4902L15.0875 20.2569C14.9568 19.1437 15.3179 17.7418 15.9739 16.6265L14.25 15.6125ZM20.2203 15.1302L20.3452 15.2401L21.6665 13.7388L21.5417 13.6289L20.2203 15.1302ZM20.7815 15.3884L20.9475 15.3773L20.8145 13.3818L20.6485 13.3928L20.7815 15.3884ZM20.3546 15.5943C20.5542 15.4429 20.6966 15.3941 20.7815 15.3884L20.6485 13.3928C20.0157 13.435 19.5012 13.7314 19.1459 14.0009L20.3546 15.5943ZM19.7576 16.2002C19.9574 15.9514 20.1611 15.7411 20.3546 15.5943L19.1459 14.0009C18.7767 14.2809 18.4576 14.6249 18.1982 14.9478L19.7576 16.2002ZM18.8779 17.6064C19.0297 17.279 19.3577 16.698 19.7576 16.2002L18.1982 14.9478C17.682 15.5906 17.2724 16.3145 17.0635 16.7652L18.8779 17.6064ZM18.3629 19.2914C18.4582 18.6461 18.7497 17.8774 18.8745 17.6136L17.0669 16.7579C16.8858 17.1403 16.5168 18.1025 16.3843 18.9992L18.3629 19.2914ZM18.3644 19.8885C18.3362 19.8237 18.3123 19.6336 18.3629 19.2914L16.3843 18.9992C16.3248 19.4026 16.2648 20.0747 16.5298 20.6851L18.3644 19.8885ZM18.3049 19.84C18.3253 19.8499 18.3433 19.8643 18.3556 19.878C18.3663 19.89 18.3674 19.8955 18.3644 19.8885L16.5298 20.6851C16.6831 21.038 16.9658 21.4141 17.4345 21.6407L18.3049 19.84ZM18.3514 19.8238C18.3078 19.8318 18.2845 19.831 18.278 19.8304C18.2736 19.83 18.2856 19.8306 18.3049 19.84L17.4345 21.6407C17.8857 21.8588 18.3449 21.8584 18.7126 21.7909L18.3514 19.8238ZM18.6327 19.6711C18.4848 19.7823 18.3903 19.8167 18.3514 19.8238L18.7126 21.7909C19.1744 21.7061 19.5567 21.4786 19.8347 21.2695L18.6327 19.6711ZM19.1066 19.2088C18.9362 19.409 18.7748 19.5642 18.6327 19.6711L19.8347 21.2695C20.1261 21.0504 20.3931 20.783 20.6294 20.5054L19.1066 19.2088ZM20.0548 17.6983C19.7887 18.2702 19.4476 18.8083 19.1066 19.2088L20.6294 20.5054C21.1019 19.9505 21.5362 19.2554 21.8681 18.5421L20.0548 17.6983ZM20.5373 16.0797C20.4974 16.5498 20.3227 17.1228 20.0548 17.6983L21.8681 18.5421C22.1961 17.8374 22.464 17.0294 22.5301 16.2485L20.5373 16.0797ZM20.3452 15.2401C20.4673 15.3476 20.5787 15.5901 20.5373 16.0797L22.5301 16.2485C22.5927 15.5098 22.4934 14.4665 21.6665 13.7388L20.3452 15.2401Z" fill="#222025" mask="url(#path-1-inside-1_3158_297690)"></path></svg>'
        )

        currTabs[1].insertAdjacentHTML(
          'beforeend',
          '<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.41489 6.85775L5.39836 11.0424C5.61852 11.076 9.69412 10.1302 9.89836 10.0424C10.1026 9.95464 13.2792 9.04242 12.3984 7.54242L12.9449 1.38771L11.3288 1.42986L12.0225 8.28489C12.0501 8.55761 5.65456 10.4705 5.89836 10.5424L19.1656 10.7468L19.3039 9.50715L12.8984 10.5424C12.7351 10.6011 6.78522 10.0887 6.67891 10.2243C6.5726 10.3599 4.41491 13.3718 4.39836 13.5424L3.39836 16.0424L7.39836 15.0424L9.89836 15.5424L12.8984 19.5424C12.9185 20.4374 14.1796 19.8803 14.2773 19.5629L14.0232 12.6533L13.43 13.4194L19.8242 10.6501C20.3922 10.4021 20.7039 9.64102 19.9624 9.41045L13.2792 7.41964L13.7392 7.88574L13.048 1.02326C12.96 0.160496 11.7309 0.638988 11.4293 1.06541L7.43802 6.72546L8.5942 6.21723L1.76775 4.74209C0.973505 4.57102 0.0222792 5.47118 0.691879 6.00447C1.10667 6.53185 1.41489 6.85775 1.41489 6.85775Z" fill="#222025"></path> <path d="M14.1326 19.1909L9.48785 14.0465C9.23651 13.7787 8.80169 13.8729 8.51014 13.9721L1.91241 16.2307L2.93034 16.9546L6.44913 11.0045C6.51547 10.9073 6.54748 10.7912 6.54022 10.6742C6.53295 10.5573 6.4868 10.4459 6.40891 10.3574L3.46821 6.52702C2.98563 5.89978 1.45748 6.7923 2.03054 7.51871L4.97124 11.3491L4.92851 10.6995L1.40973 16.6497C0.982447 17.3736 1.92749 17.5471 2.43018 17.3736L9.02538 15.1126L8.04766 15.0382L12.6925 20.1826C13.2303 20.7776 14.7459 19.8652 14.1326 19.1909Z" fill="#222025"></path></svg>'
        )
      }
      tabs.forEach((t) => {
        const attr = t.getAttribute('data-id')
        const item = this.$el.querySelector(`[data-category='${attr}']`)
        this.setProducts.push(item)
      })

      return true
    },

    tabsObserver() {
      this.firstMarkProductCollector()

      window.addEventListener('scroll', this.navHighlighter)
    },

    navHighlighter() {
      const sections = document.querySelectorAll('.products-columns')
      const links = document.querySelectorAll('.catalog-page__tab-link')
      const scrollY = window.pageYOffset

      const tabs = document.querySelector('.catalog-page__tabs')
      const tabItems = document.querySelectorAll('.catalog-page__tab-link')

      tabItems.forEach((i, index) => {
        if (i.classList.contains('catalog-page__tab-link_active')) {
          // tabs.scrollLeft = 0
          if (Number(index + 1) === 1) {
            tabs.scrollLeft = 0
            // Done
          }
          if (Number(index + 1) === 2) {
            tabs.scrollLeft = 190
            // Done
          }
          if (Number(index + 1) === 3) {
            tabs.scrollLeft = 450
            // Done
          }
          if (Number(index + 1) === 4) {
            tabs.scrollLeft = 700
            // Done
          }
          if (Number(index + 1) === 5) {
            tabs.scrollLeft = 950
            // Done
          }
          if (Number(index + 1) === 6) {
            tabs.scrollLeft = 1200
            // Done
          }
          if (Number(index + 1) === 7) {
            tabs.scrollLeft = 1450
            // Done
          }
          if (Number(index + 1) === 8) {
            tabs.scrollLeft = 1700
          }
          if (Number(index + 1) === 9) {
            tabs.scrollLeft = 1950
          }
          if (Number(index + 1) === 10) {
            tabs.scrollLeft = 2500
          }
        }
      })

      sections.forEach((current, index) => {
        const sectionHeight = current.offsetHeight
        const sectionTop = current.offsetTop - 220
        const sectionId = current.getAttribute('data-category')
        const sectionQueryParam = current.getAttribute('data-query')

        if (scrollY > sectionTop && scrollY <= sectionTop + sectionHeight) {
          const curr = document.querySelector(
            `.stickyBox .catalog-page__tab-link[data-id*='${sectionId}']`
          )

          if (sectionQueryParam !== this.currentQueryParam) {
            history.pushState(
              { query: sectionQueryParam },
              null,
              this.$nuxt.$route.path + '/' + sectionQueryParam
            )

            this.currentQueryParam = sectionQueryParam
          }

          links.forEach((i) =>
            i.classList.remove('catalog-page__tab-link_active')
          )

          if (curr) {
            curr.classList.add('catalog-page__tab-link_active')
          }
        }
      })
    },

    detectQueryParam() {
      let selectElByQueryParam = null
      const q = this.$route.query.category

      if (q) {
        setTimeout(() => {
          selectElByQueryParam = document.getElementById(q)
          window.scrollTo({
            top: selectElByQueryParam.offsetTop,
            behavior: 'auto'
          })
        }, 500)
      }
    },

    initLottieFiles() {
      this.prevIconLottiefile = window.lottie.loadAnimation({
        container: this.$refs.cprev,
        loop: false,
        autoplay: false,
        animationData: animeData
      })

      this.nextIconLottiefile = window.lottie.loadAnimation({
        container: this.$refs.cnext,
        loop: false,
        autoplay: false,
        animationData: animeData
      })
    },

    slideToNext() {
      this.$refs.vsc.next()
    },
    slideToPrev() {
      this.$refs.vsc.prev()
    },

    bannerToPrev(ref) {
      if (ref === 24 || ref === 19) {
        this.$refs[`vscBanner${ref}`].prev()
      } else {
        this.$refs[`vscBanner${ref}`][0].prev()
      }
    },

    bannerToNext(ref) {
      if (ref === 24 || ref === 19) {
        this.$refs[`vscBanner${ref}`].next()
      } else {
        this.$refs[`vscBanner${ref}`][0].next()
      }
    },

    initScrollMagic() {
      let offset = -50

      if (window.innerWidth < 1200) {
        offset = 0
      }

      const controller = new window.ScrollMagic.Controller()
      const scene = new window.ScrollMagic.Scene({
        triggerElement: this.$refs.triggerEl,
        triggerHook: 0,
        duration:
          this.$refs.scrollBox.offsetHeight -
          this.$refs.sticky.offsetHeight -
          45
      })
        .setPin(this.$refs.sticky)
        .addTo(controller)

      scene.offset(offset)
    },
    // Lottie files
    startPrevIconLottiefile() {
      this.prevIconLottiefile.setDirection(1)
      this.prevIconLottiefile.play()
    },

    endPrevIconLottiefile() {
      this.prevIconLottiefile.setDirection(-1)
      this.prevIconLottiefile.play()
    },

    startNextIconLottiefile() {
      this.nextIconLottiefile.setDirection(1)
      this.nextIconLottiefile.play()
    },

    endNextIconLottiefile() {
      this.nextIconLottiefile.setDirection(-1)
      this.nextIconLottiefile.play()
    }
  }
}
